import * as yup from 'yup';

import { MESSAGE_VALIDATE } from 'src/shared/constants/message';

export const loginSchema = yup.object().shape({
  staffNum: yup.string().required(MESSAGE_VALIDATE.STAFF_NUM_IS_REQUIRED),
  password: yup.string().required(MESSAGE_VALIDATE.PASSWORD_IS_REQUIRED),
});
